import { createConsumer } from '@rails/actioncable';

import { API_HOST } from '@editor2/constants/api';
import { debugLog } from '@editor2/services/debugService';

const getWebSocketURL = () => {
	const jwt = localStorage.getItem('accessToken');

	if (!jwt) {
		debugLog('websocket', 'WebSocket URL requested but no accessToken in localStorage — connection will likely be rejected');
	}

	return `${API_HOST}/cable?jwt=${jwt}`;
};

export default createConsumer(getWebSocketURL);
